var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { IDENTIFY_FORM_NAME, CHALLENGE_AUTHENTICATOR_KEY_FORM_NAME, ENROLL_PROFILE_FORM_NAME } from "../constants/okta-constants";
import { messages } from "../constants/mode-messages";
import { ModeName } from "../constants/mode-names";
var WISHLIST_BAG = ModeName.WISHLIST_BAG, WISHLIST_CDP = ModeName.WISHLIST_CDP, WISHLIST_LANDING = ModeName.WISHLIST_LANDING, WISHLIST_PDP = ModeName.WISHLIST_PDP, BIS_PDP = ModeName.BIS_PDP, BIS_MY_BAG = ModeName.BIS_MY_BAG, WE_MADE_TOO_MUCH_MARKDOWN_PDP = ModeName.WE_MADE_TOO_MUCH_MARKDOWN_PDP, SFL_BAG = ModeName.SFL_BAG, LOGIN_CHECKOUT_MODAL = ModeName.LOGIN_CHECKOUT_MODAL, CHECKOUT_STEP_ZERO = ModeName.CHECKOUT_STEP_ZERO, DETECT_ACCOUNT = ModeName.DETECT_ACCOUNT, DETECT_ACCOUNT_OCP = ModeName.DETECT_ACCOUNT_OCP;
var commonModeOptions = {
    modeDefaultForm: IDENTIFY_FORM_NAME,
    modeMessages: null,
    showToggleButton: true,
    showContinueAsGuest: false,
    createAccountOpen: false,
    showModesOnForms: [IDENTIFY_FORM_NAME, ENROLL_PROFILE_FORM_NAME]
};
var commonDetectAccountModeOptions = {
    modeDefaultForm: CHALLENGE_AUTHENTICATOR_KEY_FORM_NAME,
    showContinueAsGuest: true,
    showModesOnForms: [
        ENROLL_PROFILE_FORM_NAME,
        CHALLENGE_AUTHENTICATOR_KEY_FORM_NAME
    ]
};
export var modeOptions = (_a = {},
    _a[WISHLIST_BAG] = __assign(__assign({}, commonModeOptions), { modeMessages: messages[WISHLIST_BAG] }),
    _a[WISHLIST_CDP] = __assign(__assign({}, commonModeOptions), { modeMessages: messages[WISHLIST_CDP] }),
    _a[WISHLIST_LANDING] = __assign(__assign({}, commonModeOptions), { modeMessages: messages[WISHLIST_LANDING] }),
    _a[WISHLIST_PDP] = __assign(__assign({}, commonModeOptions), { modeMessages: messages[WISHLIST_PDP] }),
    _a[BIS_PDP] = __assign(__assign({}, commonModeOptions), { modeMessages: messages[BIS_PDP] }),
    _a[BIS_MY_BAG] = __assign(__assign({}, commonModeOptions), { modeMessages: messages[BIS_MY_BAG] }),
    _a[WE_MADE_TOO_MUCH_MARKDOWN_PDP] = __assign(__assign({}, commonModeOptions), { createAccountOpen: true, modeMessages: messages[WE_MADE_TOO_MUCH_MARKDOWN_PDP] }),
    _a[SFL_BAG] = __assign(__assign({}, commonModeOptions), { modeMessages: messages[SFL_BAG] }),
    _a[LOGIN_CHECKOUT_MODAL] = __assign(__assign({}, commonModeOptions), { modeMessages: messages[LOGIN_CHECKOUT_MODAL] }),
    _a[CHECKOUT_STEP_ZERO] = __assign(__assign({}, commonModeOptions), { modeMessages: messages[CHECKOUT_STEP_ZERO] }),
    _a[DETECT_ACCOUNT] = __assign(__assign(__assign({}, commonModeOptions), commonDetectAccountModeOptions), { modeMessages: messages[DETECT_ACCOUNT] }),
    _a[DETECT_ACCOUNT_OCP] = __assign(__assign(__assign({}, commonModeOptions), commonDetectAccountModeOptions), { modeMessages: messages[DETECT_ACCOUNT_OCP] }),
    _a);
